var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.miceLink==='2d94b75de2dd4b0cb5163507473f560a')?_c('index2',{attrs:{"index2":""}}):_c('index1')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }